import { useReducer, useState } from "react"
import { useEffect } from "react"
import { asArray, resolveExpression } from "../../utils"
import { useMemo } from "react"
import * as isEqual from "react-fast-compare"
import { useStoredMemo } from "../../useStoredMemo"
//import clonedeep from "lodash.clonedeep"


const emptyArr = []

export const fieldSelectOptions = ({ global = {}, local = {} } = {}) => field => {
	if (field.type !== "select") return emptyArr

	const newobj = resolveExpression(field.options, { global, local })

	if (!newobj) return emptyArr

	const optArr = typeof newobj === "string" ? newobj.split(";") : asArray(newobj)

	return optArr.filter(e => !!e).map(item =>
		typeof item === "string"
			? { value: item, label: item }
			: { ...item, value: item[field.option_value_path || "value"], label: item[field.option_label_path || "label"] }
	)
}

const recalculateFieldSelectOptions = (fields, container) => previous => {
	const current = fields.map(fieldSelectOptions(container))

	if (isEqual(current, previous))
		return previous;

	window.useMultiOptionListMemo = (window.useMultiOptionList || 0) + 1
	return current;
}

export const useMultiOptionList = ({ fields = [], container = {} }) => {
	const [result, setResult] = useState([])
	const [storedFields] = useStoredMemo(fields)
	const [storedContainer] = useStoredMemo(container)

	useEffect(() => {
		const reload = () => {
			setResult(recalculateFieldSelectOptions(storedFields, storedContainer))
		}
		window.addEventListener('portal:option-list-refresh', reload)

		reload()

		return () => window.removeEventListener('portal:option-list-refresh', reload)
	}, [storedFields, storedContainer])

	return result;
}

export const useOptionList = ({ type, options, global, local, label_path, value_path }) => {
	const [optionsObj, setOptionsObj] = useReducer((a, b) => isEqual(a, b) ? a : JSON.parse(JSON.stringify(b)), null)

	useEffect(() => {
		if ((type || "select") !== "select") return;
		const newobj = resolveExpression(options, { global, local }) || null
		setOptionsObj(newobj)
	}, [type, options, global, local, setOptionsObj])

	return useMemo(() => {
		const obj = optionsObj;
		const optionsArr = (obj instanceof Array) ? obj : (typeof obj === "string" ? obj.split(";") : [obj])

		return optionsArr.filter(e => !!e).map(item =>
			typeof item === "string"
				? { value: item, label: item }
				: { ...item, value: item[value_path || "value"], label: item[label_path || "label"] }
		)
	}, [optionsObj, label_path, value_path])
}

